import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    form: {
      maxWidth: 400,
      margin: [40, "auto", 10],
    },
    separator: {
      position: "relative",
      height: 12,
    },
    separatorTitle: {
      position: "absolute",
      top: "-9px",
      left: 0,
      right: 0,
      width: 56,
      margin: [0, "auto"],
      zIndex: 2,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 500,
      backgroundColor: theme.palette.common.white,
    },
  }),
  { name: "ChangePassword" },
);
